import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { PDFExportService } from '../pdf-export.service';
import { CustomPdfExportService } from './../pdf-custom-export/custom-pdf-export.service';
import { EyePosition } from 'src/app/patients/patient/patient-chart/patient-chart.component';
declare const google: any;
@Component({
  selector: 'csi-pdf-export-line-charts',
  templateUrl: './pdf-export-line-charts.component.html',
  styleUrls: ['./pdf-export-line-charts.component.scss']
})
export class PdfExportLineChartsComponent implements OnInit, AfterViewInit {
  @Input() patientCharts: any;
  private graphData: any = {};
  public eyePosition = EyePosition;

  constructor(
    private pdfExportService: PDFExportService,
    private customPdfExportService: CustomPdfExportService
  ) {}
  ngAfterViewInit(): void {
  
    this.pdfExportService.lineChartReady$.next(true);
  }

  ngOnInit() {}
}
